<template>
  <div class="data-manage">
    <!-- 顶部标题栏 -->
    <div class="dm-header">
      <div class="dm-title">数据交互项目管理</div>
      <div class="dm-header-right">
        <div class="dm-icon-btn" title="总览" @click="goToOverview">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
          </svg>
          <span>总览</span>
        </div>
        <div class="dm-icon-btn" title="退出" @click="handleLogout">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            <polyline points="21 3 21 9 15 9" />
          </svg>
          <span>退出</span>
        </div>
      </div>
    </div>

    <!-- 表格区域 -->
    <div class="dm-table-wrapper">
      <!-- 工具栏 -->
      <div class="dm-toolbar">
        <el-input v-model="searchVal" placeholder="请输入项目名称/项目代号" style="width: 220px; margin-right: 10px;" clearable
          @keyup.enter="handleSearch" />
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="primary" @click="openAdd" style="margin-left: 10px;">
          <span style="margin-right: 4px;">+</span>新增
        </el-button>
      </div>

      <el-table v-loading="loading" :data="tableData" border style="width: 100%"
        :header-cell-style="{ background: '#a8e6ff', color: '#333', fontWeight: 600 }">
        <el-table-column prop="name" label="项目名称" align="center" min-width="120" />
        <el-table-column prop="color" label="颜色" align="center" width="100">
          <template #default="scope">
            <span class="color-block" :style="{ backgroundColor: scope.row.color }"></span>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="项目代号" align="center" width="120" />
        <el-table-column label="MQTT" align="center" min-width="160">
          <template #default="scope">
            <div v-if="scope.row.mqtt.enabled" class="protocol-info">
              <span>客户端：{{ scope.row.mqtt.clients }}</span>
              <span>今日流量：{{ scope.row.mqtt.flow }}</span>
              <svg viewBox="0 0 24 24" width="16" height="16" fill="#409eff" style="margin-left: 6px; cursor: pointer;"
                @click="openTrendDialog('mqtt', scope.row)">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#409eff" stroke-width="2"
                  fill="none" />
              </svg>
            </div>
            <span v-else class="disabled-text">未开启</span>
          </template>
        </el-table-column>
        <el-table-column label="kafka" align="center" min-width="160">
          <template #default="scope">
            <div v-if="scope.row.kafka.enabled" class="protocol-info">
              <span>客户端：{{ scope.row.kafka.clients }}</span>
              <span>今日流量：{{ scope.row.kafka.flow }}</span>
              <svg viewBox="0 0 24 24" width="16" height="16" fill="#409eff" style="margin-left: 6px; cursor: pointer;"
                @click="openTrendDialog('kafka', scope.row)">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#409eff" stroke-width="2"
                  fill="none" />
              </svg>
            </div>
            <span v-else class="disabled-text">未开启</span>
          </template>
        </el-table-column>
        <el-table-column label="srs" align="center" min-width="160">
          <template #default="scope">
            <div v-if="scope.row.srs.enabled" class="protocol-info">
              <span>客户端：{{ scope.row.srs.clients }}</span>
              <span>今日流量：{{ scope.row.srs.flow }}</span>
              <svg viewBox="0 0 24 24" width="16" height="16" fill="#409eff" style="margin-left: 6px; cursor: pointer;"
                @click="openTrendDialog('srs', scope.row)">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#409eff" stroke-width="2"
                  fill="none" />
              </svg>
            </div>
            <span v-else class="disabled-text">未开启</span>
          </template>
        </el-table-column>
        <el-table-column label="启停" align="center" width="100">
          <template #default="scope">
            <el-switch v-model="scope.row.enabled" active-color="#67c23a" inactive-color="#dcdfe6"
              @change="handleToggle(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template #default="scope">
            <el-button type="primary" link @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" link @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="dm-pagination">
        <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 50]"
          :total="total" layout="total, sizes, prev, pager, next" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </div>

    <!-- 趋势图弹窗 -->
    <el-dialog v-model="trendDialogVisible" title="趋势图" width="850px" :close-on-click-modal="false">
      <!-- 协议标签 -->
      <div class="trend-tabs">
        <div v-for="tab in protocolTabs" :key="tab.key" class="trend-tab"
          :class="{ active: currentProtocol === tab.key }" @click="currentProtocol = tab.key">
          {{ tab.label }}
        </div>
      </div>

      <!-- 筛选条件 -->
      <div class="trend-filters">
        <el-select v-model="selectedProjectCode" placeholder="选择项目" style="width: 140px;">
          <el-option v-for="item in tableData" :key="item.code" :label="item.name" :value="item.code" />
        </el-select>
        <el-select v-model="trendType" style="width: 120px;">
          <el-option label="客户端" value="clients" />
          <el-option label="今日流量" value="flow" />
        </el-select>
        <el-select v-if="trendType === 'flow'" v-model="timeRange" style="width: 120px;" @change="handleTimeRangeChange">
          <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-if="trendType === 'clients'" v-model="platCode" style="width: 120px;" @change="handleTimeRangeChange">
          <el-option v-for="item in tendencyClientChoice" :key="item" :label="item" :value="item" />
        </el-select>
        <template v-if="timeRange === 4">
          <el-date-picker v-model="startTime" type="date" placeholder="开始时间" style="width: 150px;"
            value-format="YYYY-MM-DD" />
          <el-date-picker v-model="endTime" type="date" placeholder="结束时间" style="width: 150px;"
            value-format="YYYY-MM-DD" />
        </template>
        <el-button type="primary" @click="queryTrend">查询</el-button>
      </div>

      <!-- 折线图 -->
      <div class="trend-chart">
        <LineChart v-if="trendDialogVisible" ref="trendChart" :data="trendData" :labels="trendLabels" :height="260" />
      </div>
    </el-dialog>

    <!-- 新增/编辑弹窗 -->
    <el-dialog v-model="formDialogVisible" :title="isEdit ? '编辑项目' : '新增项目'" width="1400px" :close-on-click-modal="false"
      @close="resetForm">
      <el-form :model="formData" label-width="90px" label-position="right">
        <div class="form-layout">
          <!-- 左列 -->
          <div class="form-col">
            <!-- 基本信息 -->
            <div class="form-block">
              <div class="block-title">基本信息</div>
              <el-form-item label="项目名称">
                <el-input v-model="formData.name" placeholder="请输入项目名称" />
              </el-form-item>
              <el-form-item label="项目代号">
                <el-input v-model="formData.code" placeholder="请输入项目代号" />
              </el-form-item>
              <el-form-item label="颜色">
                <el-color-picker v-model="formData.color" />
              </el-form-item>
              <el-form-item label="经度">
                <el-input v-model="formData.longitude" placeholder="请输入经度" />
              </el-form-item>
              <el-form-item label="纬度">
                <el-input v-model="formData.latitude" placeholder="请输入纬度" />
              </el-form-item>
              <el-form-item label="启停">
                <el-switch v-model="formData.enabled" active-color="#67c23a" inactive-color="#dcdfe6" />
              </el-form-item>
            </div>
            <div class="form-block">
              <div class="block-title">webSocket</div>
              <el-form-item label="本地启动">
                <el-input v-model="formData.websocket.ip" placeholder="请输入IP" />
              </el-form-item>
              <el-form-item label="本地端口">
                <el-input v-model="formData.websocket.port" placeholder="请输入端口" />
              </el-form-item>
              <el-form-item label="ws类型">
                <el-radio-group v-model="formData.websocket.wsType">
                  <el-radio label="ws">ws</el-radio>
                  <el-radio label="wss">wss</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="外部访问">
                <el-input v-model="formData.websocket.ip2" placeholder="请输入外部访问" />
              </el-form-item>
              <el-form-item label="外部端口">
                <el-input v-model="formData.websocket.port2" placeholder="请输入端口" />
              </el-form-item>
            </div>
          </div>

          <div class="form-col">
            <!-- MQTT -->
            <div class="form-block">
              <div class="block-title">MQTT</div>
              <el-form-item label="启用">
                <el-switch v-model="formData.mqtt.enabled" active-color="#67c23a" inactive-color="#dcdfe6" />
              </el-form-item>
              <el-form-item label="tcp地址IP">
                <el-input v-model="formData.mqtt.ip" placeholder="请输入tcp地址IP" />
              </el-form-item>
              <el-form-item label="tcp端口">
                <el-input v-model="formData.mqtt.port" placeholder="请输入tcp端口" />
              </el-form-item>
              <el-form-item label="ws地址IP">
                <el-input v-model="formData.mqtt.ip2" placeholder="请输入ws地址IP" />
              </el-form-item>
              <el-form-item label="ws端口">
                <el-input v-model="formData.mqtt.port2" placeholder="请输入ws端口" />
              </el-form-item>
              <el-form-item label="账号">
                <el-input v-model="formData.mqtt.account" placeholder="请输入账号" />
              </el-form-item>
              <el-form-item label="密码">
                <el-input v-model="formData.mqtt.password" type="password" show-password placeholder="请输入密码" />
              </el-form-item>
              <el-form-item label="管理IP">
                <el-input v-model="formData.mqtt.admin_ip" placeholder="请输入管理地址IP" />
              </el-form-item>
              <el-form-item label="管理端口">
                <el-input v-model="formData.mqtt.admin_port" placeholder="请输入管理端口" />
              </el-form-item>
              <el-form-item label="管理账号">
                <el-input v-model="formData.mqtt.admin_account" placeholder="请输入管理账号" />
              </el-form-item>
              <el-form-item label="管理密码">
                <el-input v-model="formData.mqtt.admin_password" type="password" show-password placeholder="请输入管理密码" />
              </el-form-item>
            </div>
          </div>

          <div class="form-col">
            <!-- KAFKA -->
            <div class="form-block">
              <div class="block-title">KAFKA</div>
              <el-form-item label="启用">
                <el-switch v-model="formData.kafka.enabled" active-color="#67c23a" inactive-color="#dcdfe6" />
              </el-form-item>
              <el-form-item label="地址IP">
                <el-input v-model="formData.kafka.ip" placeholder="请输入地址IP" />
              </el-form-item>
              <el-form-item label="端口">
                <el-input v-model="formData.kafka.port" placeholder="请输入端口" />
              </el-form-item>
              <el-form-item label="账号">
                <el-input v-model="formData.kafka.account" placeholder="请输入账号" />
              </el-form-item>
              <el-form-item label="密码">
                <el-input v-model="formData.kafka.password" type="password" show-password placeholder="请输入密码" />
              </el-form-item>
              <el-form-item label="groupId">
                <el-input v-model="formData.kafka.group_id" placeholder="请输入 groupId" />
              </el-form-item>
              <el-form-item label="管理IP">
                <el-input v-model="formData.kafka.admin_ip" placeholder="请输入管理地址IP" />
              </el-form-item>
              <el-form-item label="管理端口">
                <el-input v-model="formData.kafka.admin_port" placeholder="请输入管理端口" />
              </el-form-item>
              <el-form-item label="管理账号">
                <el-input v-model="formData.kafka.admin_account" placeholder="请输入管理账号" />
              </el-form-item>
              <el-form-item label="管理密码">
                <el-input v-model="formData.kafka.admin_password" type="password" show-password placeholder="请输入管理密码" />
              </el-form-item>
            </div>
          </div>

          <!-- 右列：SRS -->
          <div class="form-col">
            <div class="form-block">
              <div class="block-title">SRS</div>
              <el-form-item label="启用">
                <el-switch v-model="formData.srs.enabled" active-color="#67c23a" inactive-color="#dcdfe6" />
              </el-form-item>
              <el-form-item label="地址IP">
                <el-input v-model="formData.srs.ip" placeholder="请输入地址IP" />
              </el-form-item>
              <el-form-item label="端口">
                <el-input v-model="formData.srs.port" placeholder="请输入端口" />
              </el-form-item>
              <el-form-item label="账号">
                <el-input v-model="formData.srs.account" placeholder="请输入账号" />
              </el-form-item>
              <el-form-item label="密码">
                <el-input v-model="formData.srs.password" type="password" show-password placeholder="请输入密码" />
              </el-form-item>
              <el-form-item label="管理IP">
                <el-input v-model="formData.srs.admin_ip" placeholder="请输入管理地址IP" />
              </el-form-item>
              <el-form-item label="管理端口">
                <el-input v-model="formData.srs.admin_port" placeholder="请输入管理端口" />
              </el-form-item>
              <el-form-item label="管理账号">
                <el-input v-model="formData.srs.admin_account" placeholder="请输入管理账号" />
              </el-form-item>
              <el-form-item label="管理密码">
                <el-input v-model="formData.srs.admin_password" type="password" show-password placeholder="请输入管理密码" />
              </el-form-item>

              <!-- 扩展信息列表 -->
              <div class="stream-list">
                <div v-for="(ext, idx) in formData.srs.srsExtInfoList" :key="idx" class="stream-item">
                  <div class="stream-header">
                    <span>扩展 {{ idx + 1 }}</span>
                    <el-button v-if="formData.srs.srsExtInfoList.length > 1" type="danger" link size="small"
                      @click="removeStream(idx)">-</el-button>
                  </div>
                  <el-form-item label="名称">
                    <el-input v-model="ext.name" placeholder="请输入名称" />
                  </el-form-item>
                  <el-form-item label="站点号">
                    <el-input v-model="ext.siteId" placeholder="请输入站点号" />
                  </el-form-item>
                  <el-form-item label="类型">
                    <el-select v-model="ext.imageType" placeholder="请选择类型">
                      <el-option label="可见光" value="light" />
                      <el-option label="热成像" value="ird" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="地址">
                    <el-input v-model="ext.addressUrl" placeholder="请输入IP地址" />
                  </el-form-item>
                  <el-form-item label="账号">
                    <el-input v-model="ext.account" placeholder="请输入账号" />
                  </el-form-item>
                  <el-form-item label="密码">
                    <el-input v-model="ext.password" type="password" show-password placeholder="请输入密码" />
                  </el-form-item>
                </div>
                <el-button type="primary" link size="small" @click="addStream">
                  <span style="margin-right: 2px;">+</span>添加扩展
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </el-form>

      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="saveForm">保存</el-button>
          <el-button @click="formDialogVisible = false">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from "element-plus";
import LineChart from "./LineChart.vue";
import { getProjectPage, addProject, editProject, deleteProject } from "../api/DataManage";
import { post, get } from "@/api/apiClient";

export default {
  name: "DataManage",
  components: {
    LineChart,
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      searchVal: "",
      tableData: [],
      // 趋势图弹窗
      dateOptions: [
        { label: "今日", value: 0, },
        { label: "近7天", value: 1, },
        { label: "本月", value: 2, },
        { label: "本年", value: 3, },
        { label: "自定义", value: 4, },
      ],
      trendDialogVisible: false,
      currentProtocol: "mqtt",
      selectedProjectCode: "",
      selectedProjectInfo: {},
      trendType: "",
      timeRange: 0,
      platCode: "",
      startTime: "",
      endTime: "",
      protocolTabs: [
        { key: "mqtt", label: "MQTT" },
        { key: "kafka", label: "kafka" },
        { key: "srs", label: "srs" },
      ],
      trendData: [100, 120, 220, 180, 110, 190, 160, 150],
      trendLabels: ["0点", "4点", "8点", "12点", "16点", "20点", "24点"],
      // 新增/编辑表单
      formDialogVisible: false,
      isEdit: false,
      editingIndex: -1,
      formData: this.getDefaultForm(),
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
        };
        const searchVal = (this.searchVal || "").trim();
        if (searchVal) params.searchVal = searchVal;
        const res = await getProjectPage(params);
        const body = res.data || {};
        if (body.code === 200) {
          const result = body.data || {};
          this.total = result.total || 0;
          this.tableData = (result.list || []).map(this.mapProjectRow);
        } else {
          ElMessage.error(body.msg || "获取项目列表失败");
        }
      } catch (e) {
        console.error("getProjectPage error:", e);
        ElMessage.error("获取项目列表失败");
      } finally {
        this.loading = false;
      }
    },
    mapProjectRow(item) {
      const connList = item.connList || [];
      const findConn = (type) => connList.find((c) => c.type === type);
      const mqttConn = findConn("mqtt");
      const kafkaConn = findConn("kafka");
      const srsConn = findConn("srs");
      const websocketConn = findConn("websocket");
      return {
        id: item.id,
        name: item.name,
        color: item.color,
        code: item.code,
        longitude: item.longitude,
        latitude: item.latitude,
        use_status: item.use_status,
        enabled: item.use_status === 0,
        created_at: item.created_at,
        updated_at: item.updated_at,
        mqtt: {
          ...mqttConn,
          enabled: mqttConn ? mqttConn.use_status === 0 : false,
          clients: mqttConn ? mqttConn.clients : 0,
          flow: mqttConn ? mqttConn.flux : 0,
        },
        kafka: {
          ...kafkaConn,
          enabled: kafkaConn ? kafkaConn.use_status === 0 : false,
          clients: kafkaConn ? kafkaConn.clients : 0,
          flow: kafkaConn ? kafkaConn.flux : 0,
        },
        srs: {
          ...srsConn,
          enabled: srsConn ? srsConn.use_status === 0 : false,
          clients: srsConn ? srsConn.clients : 0,
          flow: srsConn ? srsConn.flux : 0,
          srsExtInfoList: srsConn ? srsConn.srs_ext_info || [] : [],
        },
        websocket: {
          ...(websocketConn || {}),
        },
      };
    },
    async handleSearch() {
      // 列表查询：searchVal 支持按项目名称/编码搜索，留空则查全部
      this.currentPage = 1;
      await this.fetchList();
      if (!this.tableData.length) {
        ElMessage.warning("未查询到匹配的项目");
      }
    },
    getDefaultForm() {
      return {
        name: "",
        color: "#5b8def",
        code: "",
        longitude: "",
        latitude: "",
        enabled: true,
        websocket:{
          ip: "",
          port: "",
          wsType: "",
          ip2: "",
          port2: "",
          type: "websocket",
        },
        mqtt: {
          enabled: false,
          ip: "",
          port: "",
          account: "",
          password: "",
          admin_ip: "",
          admin_port: "",
          admin_account: "",
          admin_password: "",
        },
        kafka: {
          enabled: false,
          ip: "",
          port: "",
          account: "",
          password: "",
          group_id: "",
          admin_ip: "",
          admin_port: "",
          admin_account: "",
          admin_password: "",
        },
        srs: {
          enabled: false,
          ip: "",
          port: "",
          account: "",
          password: "",
          admin_ip: "",
          admin_port: "",
          admin_account: "",
          admin_password: "",
          srsExtInfoList: [
            { name: "", addressUrl: "", account: "", password: "", siteId: "", imageType: "" },
          ],
        },
      };
    },
    openAdd() {
      this.isEdit = false;
      this.editingIndex = -1;
      this.formData = this.getDefaultForm();
      this.formDialogVisible = true;
    },
    resetForm() {
      this.formData = this.getDefaultForm();
      this.isEdit = false;
      this.editingIndex = -1;
    },
    addStream() {
      this.formData.srs.srsExtInfoList.push({ name: "", addressUrl: "", account: "", password: "", siteId: "", imageType: "" });
    },
    removeStream(idx) {
      this.formData.srs.srsExtInfoList.splice(idx, 1);
    },
    async saveForm() {
      if (!this.formData.name.trim()) {
        ElMessage.warning("请输入项目名称");
        return;
      }
      if (!this.formData.code.trim()) {
        ElMessage.warning("请输入项目代号");
        return;
      }

      // 构建 connList：只包含已启用的协议
      const connList = [];
      const { mqtt, kafka, srs, websocket } = this.formData;

      if (mqtt.enabled) {
        const conn = {
          type: "mqtt",
          use_status: 0,
          ip: mqtt.ip,
          port: mqtt.port,
          ip2: mqtt.ip2,
          port2: mqtt.port2,
          account: mqtt.account,
          password: mqtt.password,
          admin_ip: mqtt.admin_ip,
          admin_port: mqtt.admin_port,
          admin_account: mqtt.admin_account,
          admin_password: mqtt.admin_password,
        };
        if (mqtt.id) conn.id = mqtt.id;
        connList.push(conn);
      }
      if (kafka.enabled) {
        const conn = {
          type: "kafka",
          use_status: 0,
          ip: kafka.ip,
          port: kafka.port,
          account: kafka.account,
          password: kafka.password,
          group_id: kafka.group_id,
          admin_ip: kafka.admin_ip,
          admin_port: kafka.admin_port,
          admin_account: kafka.admin_account,
          admin_password: kafka.admin_password,
        };
        if (kafka.id) conn.id = kafka.id;
        connList.push(conn);
      }
      if (srs.enabled) {
        const extList = (srs.srsExtInfoList || []).filter(
          (s) => s.name || s.addressUrl
        );
        const conn = {
          type: "srs",
          use_status: 0,
          ip: srs.ip,
          port: srs.port,
          account: srs.account,
          password: srs.password,
          admin_ip: srs.admin_ip,
          admin_port: srs.admin_port,
          admin_account: srs.admin_account,
          admin_password: srs.admin_password,
          srsExtInfoList: extList.map((s) => ({
            name: s.name,
            addressUrl: s.addressUrl,
            account: s.account,
            password: s.password,
            siteId: s.siteId,
            imageType: s.imageType,
          })),
        };
        if (srs.id) conn.id = srs.id;
        connList.push(conn);
      }
      if(websocket){
        const conn = {
          type: "websocket",
          use_status: 0,
          ip: websocket.ip,
          wsType: websocket.wsType,
          port: websocket.port,
          ip2: websocket.ip2,
          port2: websocket.port2,
        };
        if (websocket.id) conn.id = websocket.id;
        connList.push(conn);
      }
      const payload = {
        code: this.formData.code,
        name: this.formData.name,
        color: this.formData.color,
        longitude: this.formData.longitude === "" ? null : parseFloat(this.formData.longitude),
        latitude: this.formData.latitude === "" ? null : parseFloat(this.formData.latitude),
        useStatus: this.formData.enabled ? 0 : 1,
        connList,
      };

      if (this.isEdit && this.editingIndex >= 0) {
        const origin = this.tableData[this.editingIndex] || {};
        payload.id = origin.id;
        try {
          const res = await editProject(payload);
          const body = res.data || {};
          if (body.code === 200) {
            ElMessage.success("编辑成功");
            this.formDialogVisible = false;
            this.fetchList();
          } else {
            ElMessage.error(body.msg || "编辑项目失败");
          }
        } catch (e) {
          console.error("editProject error:", e);
          ElMessage.error("编辑项目失败");
        }
      } else {
        try {
          const res = await addProject(payload);
          const body = res.data || {};
          if (body.code === 200) {
            ElMessage.success("新增成功");
            this.formDialogVisible = false;
            this.fetchList();
          } else {
            ElMessage.error(body.msg || "新增项目失败");
          }
        } catch (e) {
          console.error("addProject error:", e);
          ElMessage.error("新增项目失败");
        }
      }
    },
    async openTrendDialog(protocol, row) {
      this.currentProtocol = protocol;
      this.selectedProjectCode = row.code;
      this.selectedProjectInfo = row;
      this.trendDialogVisible = true;
      await this.getTendencyClientChoice();
      this.queryTrend();
      this.$nextTick(() => {
        if (this.$refs.trendChart) {
          this.$refs.trendChart.handleResize();
        }
      });
    },
    handleTimeRangeChange() {
      if (this.timeRange === "today") {
        this.startTime = "";
        this.endTime = "";
      }
    },
    async getTendencyClientChoice(){
      const res = await post("/admin/dataSwapProject/getTendencyClientChoice",{
        projectCode	: this.selectedProjectCode,
        connType: this.currentProtocol,
      })
      if(res.data.code==200){
        this.tendencyClientChoice = res.data.data || [];
      }
    },
    async queryTrend() {
      // 模拟查询，生成随机趋势数据
      /* this.trendData = Array.from({ length: 7 }, () =>
        Math.floor(Math.random() * 200) + 50
      );
      console.log(this.trendData, '趋势数据'); */
      const params = {
        platCode: this.platCode||"",
        connType: this.currentProtocol,
        projectCode: this.selectedProjectCode,
        dateType: this.timeRange,
      };
      if(this.timeRange==4){
        params.begin = this.startTime;
        params.end = this.endTime;
      }
      const res = await post("/admin/dataSwapProject/getTendencyChart", params)
      if(res.data.code==200){
        this.trendLabels = res.data.data.xAxis || [];
        this.trendData = res.data.data.yAxis || [];
      }
    },
    async handleToggle(row) {
      try {
        const res = await editProject({
          id: row.id,
          useStatus: row.enabled ? 0 : 1,
        });
        const body = res.data || {};
        if (body.code === 200) {
          row.use_status = row.enabled ? 0 : 1;
          ElMessage.success(`${row.name} 已${row.enabled ? "开启" : "停止"}`);
        } else {
          row.enabled = !row.enabled;
          ElMessage.error(body.msg || "切换状态失败");
        }
      } catch (e) {
        console.error("editProject error:", e);
        row.enabled = !row.enabled;
        ElMessage.error("切换状态失败");
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.fetchList();
    },
    handleEdit(row) {
      const index = this.tableData.indexOf(row);
      this.editingIndex = index;
      this.isEdit = true;
      // 深拷贝行数据到表单，缺失字段用默认值补齐
      const base = this.getDefaultForm();
      this.formData = {
        ...base,
        ...row,
        mqtt: { ...base.mqtt, ...(row.mqtt || {}) },
        kafka: { ...base.kafka, ...(row.kafka || {}) },
        srs: {
          ...base.srs,
          ...(row.srs || {}),
          srsExtInfoList: (row.srs && row.srs.srsExtInfoList && row.srs.srsExtInfoList.length)
            ? row.srs.srsExtInfoList.map((s) => ({ ...s }))
            : [{ name: "", addressUrl: "", account: "", password: "" }],
        },
        websocket: {
          ...base.websocket,
          ...(row.websocket || {}),
        },
      };
      this.formDialogVisible = true;
    },
    handleDelete(row) {
      ElMessageBox.confirm(`确认删除项目「${row.name}」吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const res = await deleteProject([row.id]);
            const body = res.data || {};
            if (body.code === 200) {
              ElMessage.success("删除成功");
              this.fetchList();
            } else {
              ElMessage.error(body.msg || "删除项目失败");
            }
          } catch (e) {
            console.error("deleteProject error:", e);
            ElMessage.error("删除项目失败");
          }
        })
        .catch(() => { });
    },
    goToOverview() {
      this.$router.push("/data-interaction");
    },
    handleLogout() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped lang="less">
.data-manage {
  width: 100%;
  min-height: 100vh;
  background-color: #3a7ca5;
  font-family: "Microsoft YaHei", sans-serif;
}

/* ===== 顶部标题栏 ===== */
.dm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 30px;
  background-color: #3a7ca5;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.dm-title {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}

.dm-header-right {
  display: flex;
  gap: 24px;
}

.dm-icon-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  color: #fff;
  transition: opacity 0.3s;

  span {
    font-size: 12px;
    margin-top: 2px;
  }

  &:hover {
    opacity: 0.75;
  }
}

/* ===== 表格区域 ===== */
.dm-table-wrapper {
  padding: 30px;
}

.color-block {
  display: inline-block;
  width: 22px;
  height: 22px;
  vertical-align: middle;
}

.protocol-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 13px;
  color: #333;
}

.disabled-text {
  color: #999;
  font-size: 13px;
}

.dm-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* ===== 趋势图弹窗 ===== */
.trend-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}

.trend-tab {
  padding: 6px 20px;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s;

  &.active {
    background: #409eff;
    border-color: #409eff;
    color: #fff;
  }

  &:hover:not(.active) {
    color: #409eff;
    border-color: #c6e2ff;
  }
}

.trend-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
}

.trend-chart {
  width: 100%;
  height: 280px;
}

/* ===== 工具栏 ===== */
.dm-toolbar {
  margin-bottom: 16px;
}

/* ===== 新增/编辑表单 ===== */
.form-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.form-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-block {
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  padding: 12px 14px 4px;
  background: #fafafa;
}

.block-title {
  font-weight: 600;
  font-size: 14px;
  color: #303133;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #ebeef5;
}

.stream-list {
  margin-top: 8px;
}

.stream-item {
  border: 1px dashed #c0c4cc;
  border-radius: 4px;
  padding: 10px 12px 2px;
  margin-bottom: 10px;
  background: #fff;
}

.stream-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #606266;
  margin-bottom: 6px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
